module.exports = __webpack_public_path__ + "static/media/clock.50e20d66.svg";